export const CONTACTS = 'CONTACTS'
export const CONTACT = 'CONTACT'
export const CONTACT_INVITE_USER = 'CONTACT_INVITE_USER'
export const CONTACT_INVITE_LEGACY = 'CONTACT_INVITE_LEGACY'
export const CONTACT_SEND_INVITE = 'CONTACT_SEND_INVITE'
export const CONTACT_REVOKE_INVITE = 'CONTACT_REVOKE_INVITE'
export const CONTACT_DEACTIVATE_USER = 'CONTACT_DEACTIVATE_USER'
export const CONTACT_DELETE_USER = 'CONTACT_DELETE_USER'
export const CONTACT_FORCE_PASSWORD = 'CONTACT_FORCE_PASSWORD'
export const CONTACT_RESET_PASSWORD = 'CONTACT_RESET_PASSWORD'
export const CONTACT_REMOVE_2FA = 'CONTACT_REMOVE_2FA'
export const CONTACT_LOGS = 'CONTACT_LOGS'
export const CONTACT_PROPERTY_HISTORY_TIMELINE = 'CONTACT_PROPERTY_HISTORY_TIMELINE'
export const CONTACT_PROPERTY_UPDATE = 'CONTACT_PROPERTY_UPDATE'

export default {
    CONTACTS,
    CONTACT,
    CONTACT_INVITE_USER,
    CONTACT_INVITE_LEGACY,
    CONTACT_SEND_INVITE,
    CONTACT_REVOKE_INVITE,
    CONTACT_DEACTIVATE_USER,
    CONTACT_DELETE_USER,
    CONTACT_FORCE_PASSWORD,
    CONTACT_RESET_PASSWORD,
    CONTACT_REMOVE_2FA,
    CONTACT_LOGS,
    CONTACT_PROPERTY_HISTORY_TIMELINE,
    CONTACT_PROPERTY_UPDATE
}